import t from"./to-string-tag-support.js";import o from"./classof.js";var r=t,a=o,i=r?{}.toString:function(){return"[object "+a(this)+"]"};export{i as default};
